/**
 * PAYMENTS ROUTES — v24 Phase B. Mounted inside `RequireCountry` + `AppShell`
 * via `routes.extra.ts`, so the page can rely on `useCountryCode()` and a
 * resolved session.
 *
 * The path is copied from `PAYMENTS_NAV_SECTION` in `domain/nav.ts` — the
 * registry is the side with the opinion, per the registers' own rule.
 */

import type { RouteObject } from 'react-router-dom';

import { ExceptionsPage } from './ExceptionsPage';

export const paymentRoutes: RouteObject[] = [
  { path: 'payments/exceptions', element: <ExceptionsPage /> },
];
